import React from 'react';

import {browserHistory, Link} from 'react-router';
import styled from 'styled-components';

import {getFilterLink} from 'app/general/dashboards/DashboardFilterbar';
import {convertLocationParamsToFetchParams, useTags} from 'app/tags/api';
import {gt} from 'app/utils/i18n';

import {DashboardSidebarCollapsableList} from './DashboardSidebarCollapsableList';

const TagsLi = styled.li`
  a {
    white-space: normal;
    text-align: left;
  }
`;

type DashboardSidebarTagsListItemProps = {
  item: any;
};

const DashboardSidebarTagsListItem = ({
  item,
}: DashboardSidebarTagsListItemProps) => {
  const link = getFilterLink(
    browserHistory,
    browserHistory.getCurrentLocation(),
    {
      tag: item.slug,
    }
  );

  return (
    <TagsLi className="tags">
      <Link
        to={link}
        className="badge badge-primary"
        activeClassName="badge-secondary"
      >
        {item.name}
      </Link>
    </TagsLi>
  );
};

export const DashboardSidebarTagsList = () => (
  <DashboardSidebarCollapsableList
    icon="fa-tags"
    noResultsMessage={gt('No tags found')}
    title={gt('Tags')}
    reduxKey="tags"
    watchModelChange="tag"
    showSearch={false}
    itemNameProcessor={(item) => item.name}
    useDataHook={useTags}
    paramsConverter={convertLocationParamsToFetchParams}
    ItemComponent={DashboardSidebarTagsListItem}
  />
);
